import React from "react";
import { MapPin, Phone, Mail, Clock, ArrowRight, Loader, Navigation } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
const ContactForm = () => {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control,
    resetForm
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div data-section-id="10135" className="flex flex-col items-center justify-center p-8 text-center bg-secondary/30 border border-secondary rounded-3xl animate-in fade-in zoom-in duration-300">
        <div className="w-12 h-12 bg-secondary/50 rounded-full flex items-center justify-center mb-4">
          <ArrowRight className="w-6 h-6 text-foreground" />
        </div>
        <h3 className="text-xl font-serif font-bold text-foreground mb-2">Message Received</h3>
        <p className="text-muted-foreground mb-6 font-sans">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="border-border text-foreground hover:bg-secondary rounded-full font-sans text-xs uppercase tracking-widest">
          Send Another Note
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="full_name" rules={{
        required: "Full Name is required"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="font-sans text-xs uppercase tracking-widest text-muted-foreground">Full Name</FormLabel>
              <FormControl>
                <Input placeholder="Natalia Voda" className="bg-background border-border/50 rounded-xl focus:ring-ring" {...field} />
              </FormControl>
              <FormMessage className="text-xs italic" />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Invalid email address"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="font-sans text-xs uppercase tracking-widest text-muted-foreground">Email Address</FormLabel>
              <FormControl>
                <Input type="email" placeholder="hello@nataliasbeauty.com" className="bg-background border-border/50 rounded-xl focus:ring-ring" {...field} />
              </FormControl>
              <FormMessage className="text-xs italic" />
            </FormItem>} />

        <FormField control={control} name="phone" rules={{
        required: "Phone Number is required"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="font-sans text-xs uppercase tracking-widest text-muted-foreground">Phone Number</FormLabel>
              <FormControl>
                <Input type="tel" placeholder="+44 1508 555000" className="bg-background border-border/50 rounded-xl focus:ring-ring" {...field} />
              </FormControl>
              <FormMessage className="text-xs italic" />
            </FormItem>} />

        <FormField control={control} name="subject" rules={{
        required: "Please select a service"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="font-sans text-xs uppercase tracking-widest text-muted-foreground">Service Interest</FormLabel>
              <FormControl>
                <select className="flex h-10 w-full items-center justify-between rounded-xl border border-border/50 bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 font-sans" {...field}>
                  <option value="" disabled>Select a service</option>
                  {["Beauty Treatment", "Aesthetics Consultation", "Massage Therapy", "Skin Analysis", "Other"].map((option, i) => <option key={i} value={option} data-index={i}>
                      {option}
                    </option>)}
                </select>
              </FormControl>
              <FormMessage className="text-xs italic" />
            </FormItem>} />
      </div>

      <FormField control={control} name="message" rules={{
      required: "Message is required"
    }} render={({
      field
    }) => <FormItem className="mt-6">
            <FormLabel className="font-sans text-xs uppercase tracking-widest text-muted-foreground">Your Message</FormLabel>
            <FormControl>
              <Textarea placeholder="Tell us how we can enhance your natural beauty..." className="min-h-[120px] bg-background border-border/50 rounded-xl focus:ring-ring" {...field} />
            </FormControl>
            <FormMessage className="text-xs italic" />
          </FormItem>} />

      {submitError && <div className="mt-6 p-4 bg-destructive/10 border border-destructive/20 rounded-xl text-destructive text-xs font-sans">
          {submitError}
        </div>}

      <div className="mt-8 flex justify-end">
        <Button type="submit" size="lg" disabled={isSubmitting} className="w-full md:w-auto min-w-[200px] rounded-full bg-foreground text-background hover:bg-foreground/90 font-sans text-xs uppercase tracking-widest">
          {isSubmitting ? <>
              <Loader className="mr-2 h-4 w-4 animate-spin" />
              Sending...
            </> : "Send Message"}
        </Button>
      </div>
    </Form>;
};
export default function ReachCalciumHospital() {
  const address = "33 Norwich Road, Brooke, Norwich NR15 1AB, United Kingdom";
  const mapUrl = `https://maps.google.com/maps?q=${encodeURIComponent(address)}&t=&z=15&ie=UTF8&iwloc=&output=embed`;
  return <section id="visit-our-sanctuary" className="flex flex-col w-full bg-background text-foreground">
      {}
      <div className="w-full h-[450px] lg:h-[550px] bg-muted relative overflow-hidden border-b border-border/20">
        <iframe title="Natalia's Beauty Location" width="100%" height="100%" frameBorder="0" scrolling="no" marginHeight={0} marginWidth={0} src={mapUrl} className="w-full h-full grayscale-[60%] hover:grayscale-0 transition-all duration-700 contrast-[0.9] brightness-[1.02]" allowFullScreen />
        {}
        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background to-transparent pointer-events-none" />
      </div>

      {}
      <div className="container mx-auto px-4 relative z-10 -mt-24 mb-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {}
          <Card className="bg-card/80 backdrop-blur-md shadow-xl border-t-4 border-t-primary rounded-3xl hover:shadow-2xl transition-all duration-500 flex flex-col border-none">
            <CardHeader>
              <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center mb-4 text-ring">
                <Phone className="w-5 h-5" />
              </div>
              <CardTitle className="text-xl font-serif tracking-wide">Consultations</CardTitle>
              <CardDescription className="font-sans text-xs uppercase tracking-widest text-muted-foreground">Bespoke Beauty Planning</CardDescription>
            </CardHeader>
            <CardContent className="flex-grow">
              <p className="text-muted-foreground mb-2 font-sans text-sm leading-relaxed">
                Connect with our specialists to design your personalized aesthetic journey.
              </p>
              <div className="flex items-center gap-2 text-xs font-sans tracking-wider text-foreground mt-4">
                <Clock className="w-4 h-4 text-ring/60" />
                <span>By Appointment Only</span>
              </div>
            </CardContent>
            <CardFooter>
              <Button asChild className="w-full rounded-full bg-primary text-foreground hover:bg-primary/80" size="lg">
                <Link to="tel:07766733976">
                  <Phone className="mr-2 h-4 w-4" /> Call Sanctuary
                </Link>
              </Button>
            </CardFooter>
          </Card>

          {}
          <Card className="bg-card/80 backdrop-blur-md shadow-xl border-t-4 border-t-secondary rounded-3xl hover:shadow-2xl transition-all duration-500 flex flex-col border-none">
            <CardHeader>
              <div className="w-12 h-12 rounded-full bg-secondary/30 flex items-center justify-center mb-4 text-foreground">
                <MapPin className="w-5 h-5" />
              </div>
              <CardTitle className="text-xl font-serif tracking-wide">The Salon</CardTitle>
              <CardDescription className="font-sans text-xs uppercase tracking-widest text-muted-foreground">Brooke, Norwich</CardDescription>
            </CardHeader>
            <CardContent className="flex-grow">
              <p className="text-muted-foreground text-sm leading-relaxed font-sans">
                {address}
              </p>
              <div className="flex items-center gap-2 text-xs font-sans tracking-wider text-foreground mt-4">
                <Navigation className="w-4 h-4 text-secondary" />
                <span>Nestled in the heart of Brooke</span>
              </div>
            </CardContent>
            <CardFooter>
              <Button asChild variant="secondary" className="w-full rounded-full bg-secondary/50 hover:bg-secondary" size="lg">
                <Link to="https://maps.google.com" newTab>
                  <MapPin className="mr-2 h-4 w-4" /> View Map
                </Link>
              </Button>
            </CardFooter>
          </Card>

          {}
          <Card className="bg-card/80 backdrop-blur-md shadow-xl border-t-4 border-t-primary rounded-3xl hover:shadow-2xl transition-all duration-500 flex flex-col border-none">
            <CardHeader>
              <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center mb-4 text-ring">
                <Mail className="w-5 h-5" />
              </div>
              <CardTitle className="text-xl font-serif tracking-wide">Gift Vouchers</CardTitle>
              <CardDescription className="font-sans text-xs uppercase tracking-widest text-muted-foreground">Enquiries &amp; Feedback</CardDescription>
            </CardHeader>
            <CardContent className="flex-grow">
              <p className="text-muted-foreground font-sans text-sm leading-relaxed">
                Send us a private message for treatment details or wellness gift vouchers.
              </p>
            </CardContent>
            <CardFooter>
              <Button asChild variant="outline" className="w-full rounded-full border-border/50 hover:bg-primary/10" size="lg">
                <Link to="#reach_form_contact">
                  <Mail className="mr-2 h-4 w-4" /> Write to Us
                </Link>
              </Button>
            </CardFooter>
          </Card>
        </div>
      </div>

      {}
      <div id="reach_form_contact" className="container mx-auto px-4 pb-24">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-3xl md:text-5xl font-serif text-foreground mb-4 italic">Send us a Message</h2>
            <p className="text-muted-foreground max-w-2xl mx-auto font-sans text-sm tracking-wide">
              Whether you seek rejuvenation, clinical aesthetics, or a moment of peace through massage, 
              reach out to begin your transformation.
            </p>
          </div>

          <div className="bg-card/50 border border-border/20 rounded-[2rem] shadow-sm p-6 md:p-10 backdrop-blur-sm">
            <FormProvider formKey="visit_form_the_clinic" formId="visit_form_the_clinic" sectionName="reach-calcium-hospital" defaultValues={{
            full_name: "",
            email: "",
            phone: "",
            subject: "",
            message: ""
          }} validationRules={{
            full_name: {
              required: true
            },
            email: {
              required: true,
              pattern: "email"
            },
            phone: {
              required: true
            },
            subject: {
              required: true
            },
            message: {
              required: true
            }
          }} submitText="Send Message" successMessage="Your message has been received with care. We look forward to welcoming you.">
              <ContactForm />
            </FormProvider>
          </div>
        </div>
      </div>
    </section>;
}